
import { create } from "zustand";
import {
  assignTo,
  notification,
  updateProfileData,
  removeProfilePicture,
  globalSearch,
  setting,
  createTicket,
  uploadImage,
  getCaseData,
} from "../api";
import { getAvailableDoctorsData } from "modules/dashboards/actionables/api";
import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import { getNearestSlot } from 'modules/case_management/api/api';
import secureLocalStorage from "react-secure-storage";

export const useNotificationStore = create((set) => ({
  notificationData: [],
  searchResult: [],
  resAssign: [],
  doctorsList: [],
  assignedOptions: [],
  ticketResponse: [],
  imageData: [],
  ticketCaseData: [],
  refreshTicket: false,
  ticketLoading: false,
  created: false,
  isLoading: false,
  error: null,
  nearestSlot:null,
  fetchNotificationData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await notification();
      set({ notificationData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchSettingData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await setting();
      set({ resAssign: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchDoctorData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await getAvailableDoctorsData();
      set({ doctorsList: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchAssignData: async (data) => {
    try {
      set({ isLoading: true, error: null });
      const response = await assignTo(data);
      set({ assignedOptions: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchUploadImage: async (data, id) => {
    try {
      set({ isLoading: true, error: null });
      const response = await uploadImage(data, id);
      set({ imageData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchTicketCaseData: async (id) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getCaseData(id);
      set({ ticketCaseData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchCreateTicket: async (objData, setCreateText, setToaster,leadsFlag,fetchTicketHistory,id) => {
    try {
      set({ ticketLoading: true, error: null, created: false });
      const response = await createTicket(objData);
      set({ ticketResponse: response.data, ticketLoading: false });
      setCreateText("Ticket Created");
      setToaster("Ticket Creation", " Ticket Created", "success");
      leadsFlag&&id&&fetchTicketHistory(id);
    } catch (error) {
      let errorMessage = 'Something went wrong';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = error.response.data.message?.message;
        }
      } else {
        errorMessage = error.message;
      }
      set({ error: errorMessage, ticketLoading: false, created: false });
      setToaster(
        "Ticket Creation",
        errorMessage,
        "danger"
      );
      setCreateText(errorMessage);
    } finally{
      set({nearestSlot: null})
    }
  },
  fetchNearestSlot: async()=>{
    try {
      const response = await getNearestSlot();
      set({ nearestSlot: response.data });
    } catch (error) {
      console.error("Error:", error.message);
    }
  },
  fetchCaseData: async (data) => {
    try {
      set({ isLoading: true, error: null });
      if (data) {
        const response = await globalSearch(data);
        if (typeof response.data === "string") {
          set({ searchResult: [], isLoading: false });
        } else {
          set({ searchResult: response.data, isLoading: false });
        }
      } else {
        set({ searchResult: [] });
      }
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useProfileUpdate = create(() => ({
  updateProfile: async (data, id, setToaster,fetchProfileDetails) => {
    try {
      let profileData = new FormData();
      secureLocalStorage.setItem("first_name", data.first_name);
      secureLocalStorage.setItem("alternate_email", data.userAlternateEmail);
      await profileData.append("image", data.compressedFile);
      await profileData.append("first_name", data.first_name);
      await profileData.append("alternate_email", data.userAlternateEmail);

      await updateProfileData(id, profileData);
      setToaster("Profile Update", "Profile updated successfully", "success");
    } catch (error) {
      setToaster("Profile Update", "Failed to update profile", "danger");
    } finally {
      fetchProfileDetails();
    }
  },
  removeProfile: async (setToaster,fetchProfileDetails) => {
    try {
      await removeProfilePicture();
      setToaster(
        "Profile Update",
        "Profile picture removed successfully",
        "success"
      );
    } catch (error) {
      setToaster(
        "Profile Update",
        "Failed to remove profile picture",
        "danger"
      );
    } finally {
      fetchProfileDetails();
    }
  },
}));

export const createMeidcalEscalationTicket =create((set)=>({
  slotDetails:null,
  nearestSlot:null,
  fetchMeidcalCreateTicket: async (objData, toast) => {
    try {
      set({ ticketLoading: true, error: null, created: false });
      const response = await createTicket(objData);
      // Ticket service answers an existing open ticket with 200 + [{ status: 409, duplicate: true }].
      if (response.data?.[0]?.duplicate) {
        toast.error(response.data[0].message || "A similar ticket is already open", TOAST_MESSAGE_CSS);
        return false;
      }
      set({ slotDetails: response.data[0] });
      toast.success("Ticket booked successfully", TOAST_MESSAGE_CSS);
      return true;
    } catch (error) {
      console.log('error', error.response.data)
      if(error?.response?.data?.message.message){
        toast.error(`${error?.response?.data?.message.message}`, TOAST_MESSAGE_CSS);
      }
      else{
        toast.error(`${error?.response?.data?.message}`, TOAST_MESSAGE_CSS);
      }
      return false;
    } finally{
      set({nearestSlot: false });
    }
  },
  fetchNearestSlot: async()=>{
    try {
      const response = await getNearestSlot();
      set({ nearestSlot: response.data });
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
}))
